(() => {
  function init(root = document) {
    for (const host of root.querySelectorAll('[data-fw-native-reviews]')) {
      if (host.dataset.fwReady) continue;
      host.dataset.fwReady = 'true';
      const list = host.querySelector('[data-fw-review-list]');
      if (!list) continue;
      const items = [...list.children];
      const filter = host.querySelector('[data-fw-review-filter]');
      const sort = host.querySelector('[data-fw-review-sort]');
      const more = host.querySelector('[data-fw-review-more]');
      const status = host.querySelector('[data-fw-review-status]');
      sort.value = 'highest';
      let limit = 5;
      const render = () => {
        const order = [...items].sort((a,b) => {
          const date = b.dataset.fwReviewDate.localeCompare(a.dataset.fwReviewDate);
          const rating = Number(a.dataset.fwReviewRating) - Number(b.dataset.fwReviewRating);
          return sort.value === 'oldest' ? -date : sort.value === 'lowest' ? rating || date : sort.value === 'highest' ? -rating || date : date;
        });
        const matching = order.filter(item => filter.value === 'all' || item.dataset.fwReviewRating === filter.value);
        const shown = new Set(matching.slice(0,limit));
        order.forEach(item => { item.hidden = !shown.has(item); list.append(item); });
        more.hidden = matching.length <= limit;
        status.textContent = matching.length ? (document.documentElement.lang.toLowerCase().startsWith('fr') ? `${shown.size} sur ${matching.length} avis${filter.value==='all'?'':' avec ce nombre d’étoiles'}` : (document.documentElement.lang.toLowerCase().startsWith('it') ? `${shown.size} di ${matching.length} recensioni${filter.value==='all'?'':' con questo numero di stelle'}` : globalThis.fwExtraFormat("fw_extra.s_65b363cfb57658", `${shown.size} von ${matching.length} Bewertungen${filter.value==='all'?'':' mit dieser Sternezahl'}`, [shown.size, matching.length, filter.value==='all'?'':globalThis.fwExtraText("fw_extra.s_c97fccb213c4ed", ' mit dieser Sternezahl')]))) : (document.documentElement.lang.toLowerCase().startsWith('fr') ? "Aucun avis avec ce nombre d’étoiles." : (document.documentElement.lang.toLowerCase().startsWith('it') ? "Nessuna recensione con questo numero di stelle." : globalThis.fwExtraText("fw_extra.s_a4dcb19329fb21", 'Keine Bewertungen mit dieser Sternezahl vorhanden.')));
      };
      host.querySelector('.fw-native-controls').hidden = false;
      filter.addEventListener('change',()=>{limit=5;render();});
      sort.addEventListener('change',()=>{limit=5;render();});
      more.addEventListener('click',()=>{limit+=5;render();});
      render();
    }
    if (document.querySelector('main [data-fw-native-reviews]')) document.documentElement.classList.add('fw-native-reviews-active');
  }
  window.FeinwaelderReviews = { init };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('click',event=>{
    const link=event.target.closest('.fw-native-rating[data-fw-open-reviews]');
    if(!link)return;
    const details=document.getElementById(link.dataset.fwOpenReviews);
    if(details){details.open=true;details.querySelector('summary')?.focus({preventScroll:true});}
  });
})();
